import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollToTop = () => {

    const { pathname } = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        
        // فقط وقتی navigation معمولی باشد برو بالا
        // POP یعنی back / forward
        if (navigationType !== "POP") {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }

    }, [pathname, navigationType]);

    return null;
};

export default ScrollToTop;
